import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { TaskProvider } from "./components/TaskContext";
import { UserDataProvider } from "./components/UserDataContext";
import { SearchProvider } from "./components/SearchContext";
import Expired from "./components/Expired";
import Login from "./pages/Login";
import NoPermission from "./pages/NoPermission";
import PassResetMail from "./pages/PassResetMail";
import Performers from "./pages/Performers";
import Contributions from "./pages/Contributions";
import Tasks from "./pages/Tasks";
import PassChange from "./pages/PassChange";
import Menu from "./pages/Menu";
import InternalUsers from "./pages/InternalUsers";
import EditUser from "./pages/EditUser";
import AddTask from "./pages/TaskAdd";
import TaskEdit from "./pages/TaskEdit";
import TasksData from "./pages/TasksData";
import FilesData from "./pages/FilesData";
import TaskMap from "./pages/TaskMap";
import AppDescription from "./pages/AppDescription";
import Footer from "./components/Footer";
import Rodo from "./pages/Rodo";

export const API_URL = "https://pzitbrz.pl/api";
export const APP_NAME = "PZITB";
export const cookie = "pzitb";
export const windowWidth = 768;
export const marginBottom = "20px";
export const marginTop = "50px";
export const fontFamily = "Wix Madefor Display";

function App() {
  return (
    <>
      <UserDataProvider>
        <TaskProvider>
          <SearchProvider>
            <main className="page-content">
              <BrowserRouter basename="/">
                <Routes>
                  <Route path="/" element={<Navigate to="/login" />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/nopermission" element={<NoPermission />} />
                  <Route path="/passresetmail" element={<PassResetMail />} />
                  <Route path="/passchange" element={<PassChange />} />
                  <Route path="/performers" element={<Performers />} />
                  <Route path="/contributions" element={<Contributions />} />
                  <Route path="/addtask" element={<AddTask />} />
                  <Route path="/internalUsers" element={<InternalUsers />} />
                  <Route path="/edituser/:id" element={<EditUser />} />
                  <Route path="/taskedit" element={<TaskEdit />} />
                  <Route path="/tasksdata" element={<TasksData />} />
                  <Route path="/filesdata" element={<FilesData />} />
                  <Route path="/menu" element={<Menu />} />
                  <Route path="/expired" element={<Expired />} />
                  <Route path="/tasks" element={<Tasks />} />
                  <Route path="/taskmap" element={<TaskMap />} />
                  <Route path="/appdescription" element={<AppDescription />} />
                  <Route path="/rodo/:id" element={<Rodo />} />
                </Routes>
              </BrowserRouter>
            </main>
            <Footer />
          </SearchProvider>
        </TaskProvider>
      </UserDataProvider>
    </>
  );
}

export default App;
